import { usePermissions } from "components/context/permissionsContext";

export const useJobsitePermission = () => {
  const { userPermissions } = usePermissions();

  const hasJobsiteSavePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Jobsite" &&
      item.action === "SaveJobsite" &&
      item.hasPermission
  );
  const hasJobsiteGetPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Jobsite" &&
      item.action === "GetJobsite" &&
      item.hasPermission
  );
  const hasJobsiteDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Jobsite" &&
      item.action === "DeleteJobsite" &&
      item.hasPermission
  );
  const hasJobsiteImportPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Jobsite" &&
      item.action === "ImportJobsite" &&
      item.hasPermission
  );
  const hasAlertGetPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Jobsite" &&
      item.action === "GetAlert" &&
      item.hasPermission
  );
  const hasAlertSavePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Jobsite" &&
      item.action === "SaveAlert" &&
      item.hasPermission
  );
  const hasAlertDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "Jobsite" &&
      item.action === "DeleteAlert" &&
      item.hasPermission
  );

  const JobsitePermissionProps = {
    hasJobsiteSavePermission,
    hasJobsiteGetPermission,
    hasJobsiteDeletePermission,
    hasJobsiteImportPermission,
    hasAlertGetPermission,
    hasAlertSavePermission,
    hasAlertDeletePermission,
  };

  return {
    JobsitePermissionProps,
  };
};
